import { z } from 'zod';

export const ITEM_PERMISSIONS = {
  NONE: 'NONE',
  VIEW: 'VIEW',
  EDIT: 'EDIT',
} as const;

export const itemPermissionSchema = z.enum(ITEM_PERMISSIONS);

export type ItemPermissionDTO = z.infer<typeof itemPermissionSchema>;
